import { render } from "./ScrollToTop.vue?vue&type=template&id=ed683aa6&scoped=true"
import script from "./ScrollToTop.vue?vue&type=script&lang=js"
export * from "./ScrollToTop.vue?vue&type=script&lang=js"

import "./ScrollToTop.vue?vue&type=style&index=0&id=ed683aa6&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed683aa6"]])

export default __exports__